import React, {
    FormEvent,
    ReactElement, useEffect, useState,
} from "react";
import SchedulePicker from "../../../../components/office-hours/OfficeHours";
import TimedMessage from "../../../../components/timed-message/TimedMessage";
import { GetSettingsDocument, SettingsTimeInput, useSaveSettingsMutation } from "../../../../__generated__/api";
import { SettingsProps } from "../base";

export default function Time(props: SettingsProps): ReactElement {
    const [save] = useSaveSettingsMutation();

    const [isSaved, setIsSaved] = useState(false);
    const [settings, setSettings] = useState<SettingsTimeInput>(() => ({
        ...props.settings?.time,
        __typename: undefined,
    }));

    useEffect(() => {
        if (props.settings?.time) {
            setSettings(props.settings?.time);
        }
    }, [props.settings?.time]);

    const onSubmit = (event: FormEvent) => {
        event.preventDefault();
        (async () => {
            await save({
                refetchQueries: [
                    { query: GetSettingsDocument },
                ],
                variables: {
                    time: {
                        timezone: settings?.timezone,
                        holidayCountryCode: settings?.holidayCountryCode,
                        hoursOfOperations: settings?.hoursOfOperations,
                    },
                },
            });
            setIsSaved(true);
        })();
    };

    return (

        <form className="flex-grow-1" onSubmit={onSubmit}>
            <TimedMessage shouldShow={isSaved} title="Saved" onClose={() => setIsSaved(false)}>
                Settings saved.
            </TimedMessage>

            <SchedulePicker settings={settings} onChange={setSettings} />

            <div className="d-flex justify-content-end mt-3 fixed-bottom border-top p-3 bg-white">
                <button type="submit" className="btn btn-primary">
                    Save
                </button>
            </div>

        </form>
    );
}
